import { Component } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { UploadCsvModalComponent } from "../../../../components/modal/upload-csv-modal/upload-csv-modal.component";

@Component({
  selector: "app-upload-csv",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./upload-csv.component.html",
})
export class UploadCsvComponent {
  constructor(private modalService: NgbModal) {}

  openUploadModal() {
    const modal = this.modalService.open(UploadCsvModalComponent, {
      centered: true,
      backdrop: "static",
      size: "md"
    });

    modal.result.then((file: File) => {
      console.log("CSV ricevuto:", file);
      // qui puoi fare ciò che vuoi con il file
    });
  }
}
